import { Loader } from "@core/components";
import type { UserInfoDto } from "@core/types";
import { FlagProvider } from "@unleash/proxy-client-react";
import { createContext, PropsWithChildren, useContext } from "react";

import { Auth0Context } from "./Auth0Context";
import { useCcauToken } from "./hooks";
import { getUnleashConfig } from "./utils";

export type AccessContextProps = {
  getToken: () => Promise<string | undefined>;
  getCcauToken: () => Promise<string | undefined>;
  userInfo: UserInfoDto | undefined;
};

export const AccessContext = createContext<AccessContextProps>({
  getToken: async () => undefined,
  getCcauToken: async () => undefined,
  userInfo: undefined,
});

export const AccessProvider = ({ children }: PropsWithChildren) => {
  const { getToken } = useContext(Auth0Context);
  const { userInfo, getCcauToken, ccauAccessToken } = useCcauToken(getToken);

  if (!ccauAccessToken || !userInfo) {
    return <Loader fullScreen />;
  }

  return (
    <AccessContext.Provider
      value={{
        getToken,
        getCcauToken,
        userInfo,
      }}
    >
      <FlagProvider config={getUnleashConfig(userInfo)}>
        {children}
      </FlagProvider>
    </AccessContext.Provider>
  );
};
